// removed by extract-text-webpack-plugin
module.exports = {"mainNav":"MainNav__mainNav___2X6gk","slider":"MainNav__slider___hYDx5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/MainNav.scss
// module id = 518
// module chunks = 0